<template>
  <b-modal
    ref="modal-item-tracking"
    modal-class="modal-item-tracking"
    hide-footer
    @hidden="hideModal"
    centered
    no-close-on-backdrop
  >
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <template #modal-header="{ close }" >
      <div class="header d-flex justify-content-between w-100">
        <div class="w-100 text-center">
          <p class="titleHeader pt-2 pl-5">商品追跡</p>
        </div>
        <div class="button-modal-header d-flex flex-row">
          <b-button
            size="sm"
            class="btn-close d-flex flex-row align-items-center"
            style="color: #666563; text-decoration: none;"
            variant="link"
            @click="close()"
          >
            <i class="material-icons material-icons-outlined">close</i>
          </b-button>
        </div>
      </div>
    </template>
    <div class="modal-item-tracking-body">
      <div class="row scan-code-field">
        <validation-observer ref="validationForm" @submit.prevent="onSearch">
          <b-form>
            <validation-provider
              :name="`${scanCodeField}`"
              rules="scancodeRequired"
              mode="passive"
              v-slot="{ errors }"
              >
              <div class="row flex-nowrap align-items-center position-relative w-100">
                <div class="form-group__label">
                  <span class="required">必須</span>
                </div>
                <b-form-input
                  type="search"
                  :placeholder="`${scanCodeField}`"
                  autofocus
                  v-model="scanCode"
                  v-bind:class="{ 'border-danger bg-danger-outline': errors[0] }"
                  class="scan-code-input"
                ></b-form-input>
                <div class="search-block"><span class="search-icon material-icons" type="submit" @click="onSearch">search</span></div>
              </div>
              <span class="error-message" v-for="(error, i) in errors" :key="i"
                >{{ errors[i] }}
              </span>
            </validation-provider>
          </b-form>
        </validation-observer>
      </div>
      <div class="alert-message">
        <div
          :class="[
            errorMessageArray.length > 0
              ? 'error-msg-container'
              : hiddenErrorMsgClass
          ]"
        >
          <transition-group name="slide">
            <template v-for="item in errorMessageArray">
              <div class="error-msg-box" :key="item">
                <b-alert show variant="danger" fade>
                  <i class="material-icons report">report</i>
                  <span v-html="item"></span>
                  <i
                    class="material-icons close-message ml-auto cursor-pointer"
                    @click="handleCloseErrorMessage(item)">
                    close
                  </i>
                </b-alert>
              </div>
            </template>
          </transition-group>
        </div>
      </div>
      <div
        id="item-tracking"
        v-if="taskItemsTrackingList"
        :class="[!this.dataEmpty && checktotalResultQuantity()? 'item-tracking' : 'no-item-tracking']">
        <div class="row">
          <div id="search-group" class="col-9 search-group">
            <span class="search-date">検索日時：{{timeCurrent | formatedDate}}</span>
            <br />
            <strong class="search-info">{{productName ? `${itemScanCode}（${productName}）` : `${itemScanCode}`}}</strong>
          </div>
          <div class="col-3 print-group">
            <div class="print-button" v-print="printModal()">
              <span class="material-icons print-icon">print</span>
              <span>リストを印刷</span>
            </div>
          </div>
        </div>
        <div class="row">
          <table class="table-tracking-list table table-bordered text-center">
            <thead>
              <tr>
                <th
                @click="onSort('time')"
                class="lable-sort-time">
                  最終投下日時
                  <span
                    :class="[!onSortTime && isClickTime
                        ? 'icon-sort-time-up'
                        : 'non-icon-sort-time-up']"
                    class="text-info material-icons material-icons-outlined"
                  >
                    arrow_upward
                  </span>
                  <span
                    :class="[onSortTime && isClickTime
                        ? 'icon-sort-time-down'
                        : 'non-icon-sort-time-down']"
                    class="text-info material-icons material-icons-outlined"
                  >
                    arrow_downward
                  </span>
                </th>
                  <th class="lable-box-number">
                    <span class="text">
                      {{boxNoField}}
                    </span>
                  </th>
                <th
                @click="onSort('chute')"
                class="lable-sort-chute">
                  <span class="text">
                    {{chuteNoField}}
                  </span>
                  <span
                    :class="[onSortChute && isClickChute
                        ? 'icon-sort-chute-up'
                        : 'non-icon-sort-chute-up']"
                    class="text-info material-icons material-icons-outlined"
                  >
                    arrow_upward
                  </span>
                  <span
                      :class="[!onSortChute && isClickChute
                        ? 'icon-sort-chute-down'
                        : 'non-icon-sort-chute-down']"
                    class="text-info material-icons material-icons-outlined"
                  >
                    arrow_downward
                  </span>
                </th>
                <th class="lable-result-quantity">投入数</th>
              </tr>
            </thead>
            <tbody class="item-data" v-if="!this.dataEmpty" id="table-body">
              <template v-if="checktotalResultQuantity()">
              <tr v-for="(items, index) in taskItemsTrackingList" :key="index">
                <template>
                  <td class="cell-sort-time">{{ items.maxChuteTime | formatedDate }}</td>
                  <td class="cell-box-number">{{ items.boxNo  }}</td>
                  <td class="cell-sort-chute">{{ items.chuteNo  }}</td>
                  <td class="cell-result-quantity" v-if="isOrderTaskType">
                    {{  items.totalResultQuantity ? `${items.totalResultQuantity}/${items.totalPlanQuantity}` : `${items.totalPlanQuantity}`}}
                  </td>
                  <td class="cell-result-quantity" v-else>
                    {{  items.totalResultQuantity ? `${items.totalResultQuantity}` : `${items.totalPlanQuantity}`}}
                  </td>
                </template>
              </tr>
              </template>
            </tbody>
            <tbody v-else class="empty-table">
              <span class="empty_text">{{this.dataEmpty}}</span>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import FlashMessage from '../../common/flash-message.component.js'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    DatePicker,
    Loading,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      isLoading: false,
      onSortTime: false,
      onSortChute: false,
      isClickTime: false,
      isClickChute: false,
      taskItemsTrackingList: [],
      sort: [],
      item: {},
      chuteNoField: '',
      boxNoField: '',
      scanCodeField: '',
      scanCode: '',
      productName: '',
      timeCurrent: '',
      dataEmpty: '',
      hiddenErrorMsgClass: '',
      notSortedTask: 0,
      itemScanCode: '',
      typeSort: '',
      queryParam: {}
    }
  },
  computed: {
    ...mapGetters('flashMessage', ['errorMessageArray'])
  },
  filters: {
    formatedDate(date) {
      return date && moment(new Date(date)).format('L LT')
    }
  },
  mounted() {
    this.hiddenErrorMsgClass = ''
  },
  watch: {
    errorMessageArray() {
      if (this.errorMessageArray.length > 0) {
        this.hiddenErrorMsgClass = 'animated-error-msg-container'
      }
    }
  },
  props: ['isShowTrackingModal', 'isOrderTaskType'],
  model: {
    prop: 'isShowTrackingModal',
    event: 'changeDisplayMode'
  },
  methods: {
    ...mapActions('flashMessage', ['removeMessageFromErrorList']),
    showModal(queryParam) {
      this.queryParam = queryParam
      this.getScanCodeField()
      if (!this.scanCode) {
        this.taskItemsTrackingList = null
      }
      this.onSortTime = true
      this.isClickTime = true
      this.typeSort = 'time'
      this.$emit('changeDisplayMode', true)
      this.$refs['modal-item-tracking'].show()
    },
    hideModal() {
      this.taskItemsTrackingList = []
      this.scanCode = ''
      this.isClickChute = false
      this.dataEmpty = ''
      this.$emit('changeDisplayMode', false)
      this.$refs['modal-item-tracking'].hide()
    },
    checkEmptyData() {
      if (!parseInt(this.taskItemsTrackingList.length)) {
        this.notSortedTask
          ? this.dataEmpty = 'この商品はまだ一度も仕分けられておりません。'
          : this.dataEmpty = '未登録の商品です。'
      } else {
        this.dataEmpty = null
      }
    },
    checktotalResultQuantity() {
      let item = 0
      let check = this.taskItemsTrackingList.reduce((prevItem, currentItem) => {
        if (currentItem.totalResultQuantity > 0) {
          item++
        }
        return item > 0
      }, item)
      return check
    },
    getCurrentTime() {
      const today = new Date()
      const date = today.getFullYear() + '/' + (today.getMonth() + 1) + '/' + today.getDate()
      const time = today.getHours() + ':' + today.getMinutes()
      const dateTime = date + ' ' + time
      this.timeCurrent = dateTime
    },
    async onSort(typeSort) {
      if (typeSort === 'time') {
        this.isClickTime = true
        this.isClickChute = false
        this.onSortChute = false
        this.onSortTime = !this.onSortTime
        this.typeSort = 'time'
      } else {
        this.isClickChute = true
        this.isClickTime = false
        this.onSortTime = true
        this.onSortChute = !this.onSortChute
        this.typeSort = 'chute'
      }
      try {
        this.scanCode = this.itemScanCode
        let response = await this.getTrackItems(typeSort, this.itemScanCode)
        this.taskItemsTrackingList = response.data.trackingItems
        this.notSortedTask = response.data.notSortedTask
        this.checkEmptyData()
      } catch (error) {
        this.taskItemsTrackingList = null
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      }
    },
    async getScanCodeField() {
      let data = await this.getTrackItems(null, null)
      this.scanCodeField = this.getItemNameFromTableManagement(data.data.mstTableManagement, 'scanCode')
    },
    getSearchGroupHeight() {
      const element = document.getElementById('search-group')
      if (element) {
        return element.offsetHeight
      }
    },
    async onSearch() {
      FlashMessage.getInstance().hideAllErrorMessages()
      await this.$refs.validationForm.validate()
      if (!this.scanCode || !this.scanCode.trim()) {
        this.dataEmpty = null
        this.taskItemsTrackingList = null
        return
      }
      this.isLoading = true
      this.getCurrentTime()
      try {
        let response = await this.getTrackItems(this.typeSort, this.scanCode)
        this.taskItemsTrackingList = response.data.trackingItems
        this.notSortedTask = response.data.notSortedTask
        this.boxNoField = this.getItemNameFromTableManagement(response.data.mstTableManagement, 'boxNo')
        this.chuteNoField = this.getItemNameFromTableManagement(response.data.mstTableManagement, 'chuteNo')
        this.productName = response.data.productName
        this.isLoading = false
        this.itemScanCode = this.scanCode
        this.checkEmptyData()
      } catch (error) {
        this.isLoading = false
        this.taskItemsTrackingList = null
        this.dataEmpty = null
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      }
      this.$nextTick().then(res => {
        if (document.getElementById('table-body')) {
          // 72 is max height of search group
          if (this.getSearchGroupHeight() < 72) {
            document.getElementById('table-body').style.maxHeight = `387px`
          } else {
            document.getElementById('table-body').style.maxHeight = `344px`
          }
        }
      })
    },
    isNotNullScanCode() {
      return this.scanCode && this.scanCode.trim()
    },
    getTrackItems(typeSort, scanCodeVal) {
      let batchNo = this.queryParam.batchNo
      let batchDetailNo = this.queryParam.batchDetailNo
      let typeSortOrder = ''
      if (typeSort === 'time') {
        typeSortOrder = this.onSortTime ? '-maxChuteTime' : 'maxChuteTime'
      } else {
        typeSortOrder = this.onSortChute ? 'chuteNo' : '-chuteNo'
      }
      return this.$axios.get(
        '/func/get-tracking-items', { params: {
          batchNo,
          batchDetailNo,
          scanCode: scanCodeVal,
          sort: typeSortOrder
        }})
    },
    getItemNameFromTableManagement(mstTableManagements, isItemNoValue) {
      const mstTableManagement = mstTableManagements.find(mstTableManagement => mstTableManagement.isItemNo === isItemNoValue)
      return mstTableManagement ? mstTableManagement.itemName : ''
    },
    handleCloseErrorMessage(msg) {
      this.removeMessageFromErrorList(msg)
    },
    printModal() {
      let printModal = {
        id: 'item-tracking',
        popTitle: ' '
      }
      return printModal
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .modal-dialog {
    max-width: 40vw;
    min-width: 560px;
    margin-top: 20px;
    margin-bottom: 20px;
    @include media-breakpoint-default() {
      margin-left: 140px !important;
      margin-right: 140px !important;
    }
  }
  /deep/ .modal-content {
    min-height: 652px;
    height: 100%;
    max-width: 40vw;
    min-width: 560px;
    width: 40vw;
  }
  /deep/ .modal-header {
    border-bottom: none;
  }
  /deep/ .modal-body {
    height: 100%;
    padding-top: 0px;
  }
  /deep/ .modal.modal-item-tracking {
    overflow-y: auto;
    @include media-breakpoint-default() {
      overflow-x: auto !important;
    }
  }
  .modal-item-tracking {
    position: relative;
    .titleHeader {
      font-weight: 700;
      @include responsive-fs(20);
      line-height: 23.44px;
      text-align: center;
      margin-bottom: 0px;
    }
    .modal-item-tracking-body {
      padding: 0px 30px 0px 30px;
      align-items: center;
      .form-group {
        &__label {
          font-weight: bold;
          .required {
            width: 40px;
            @include responsive-fs(12);
            color: #B41B3E;
            border: 1px solid #B41B3E;
            margin-left: -25px;
            margin-right: 8px;
          }
        }
      }
      .scan-code-field {
        position: relative;
        padding: 0px 0px 0px 20px;
        span {
          width: 100%;
        }
        .scan-code-input {
          padding-right: 2rem;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .search-block {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          display: flex;
          .search-icon {
            padding-right: 10px;
            @include responsive-fs(24);
          }
        }
      }
      .error-message {
          color: #b41b3e;
          font-weight: 400;
          @include responsive-fs(13);
          position: relative;
          right: 14px;
          margin-left: 20px;
        }
      .item-tracking {
        .search-group {
          padding: 0px;
          @include responsive-fs(12);
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .print-group {
          display: flex;
          align-items: center;
          justify-content: end;
          padding: 0px;
          @include responsive-fs(12);
          color: #4e66a6;
          .print-button {
            cursor: pointer;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            .print-icon {
              @include responsive-fs(18);
            }
          }
        }
        .table-tracking-list {
          @include responsive-fs(12);
          table-layout: fixed;
            thead {
              width: 100%;
              display: flex;
              border-bottom: 2px solid #dee2e6;
              tr {
                width: 100% !important;
                display: flex;
                justify-content: space-evenly;
              }
              th {
                border: none;
                flex: 1;
                display: flex !important;
                align-items: center;
                justify-content: center;
              }
            }
            tbody {
              width: 100%;
              overflow: hidden auto;
              display: block;
              tr {
                width: 100% !important;
                display: flex;
                justify-content: space-evenly;
                td {
                  border: none;
                  border-top: 1px solid #dee2e6;
                  word-wrap: break-word;
                  flex: 1;
                  white-space: nowrap;
                }
              }
            }
            .item-data {
              width: 100%;
              min-height: max-content;
            }
            .empty-table {
              height: 360px;
            }
            .lable-sort-time {
              display: flex;
              align-items: center;
              position: relative;
              bottom: 1px;
              cursor: pointer;
              display: inline-block;
              white-space: nowrap;
              max-width: 30%;
            }
            .cell-sort-time {
              max-width: 30%;
            }
            .lable-box-number {
              white-space: nowrap;
              text-align: center;
              max-width: 20%;
              .text {
                overflow: hidden;
                padding-left: 0;
                position: relative;
                display: inline-block;
                width: fit-content !important;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .cell-box-number {
              max-width: 20%;
            }
            .lable-sort-chute {
              display: flex;
              align-items: center;
              cursor: pointer;
              white-space: nowrap;
              text-align: center;
              max-width: 30%;
              .text {
                overflow: hidden;
                padding-left: 0;
                position: relative;
                display: inline-block;
                width: fit-content !important;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .cell-sort-chute {
              max-width: 30%;
            }
            .lable-result-quantity {
              word-break: break-all;
              display: inline-block;
              position: relative;
              right: 0;
              max-width: 20%;
              white-space: nowrap;
            }
            .cell-result-quantity {
              max-width: 20%;
            }
            .icon-sort-time-up, .icon-sort-chute-up {
              @include responsive-fs(14);
              padding: 0 2px;
              font-weight: 500;
            }
            .icon-sort-time-down, .icon-sort-chute-down {
              position: relative;
              right: 1rem;
              @include responsive-fs(14);
              padding: 0 2px;
              font-weight: 500;
            }
            .non-icon-sort-chute-up, .non-icon-sort-time-up, .non-icon-sort-time-down, .non-icon-sort-chute-down {
              visibility: hidden;
              @include responsive-fs(14);
              padding: 0 2px;
            }
          }
      }
      .no-item-tracking {
        @extend .item-tracking;
      }
      .empty_text{
        position: relative;
        top: 15px;
        color: #8a909a;
        @include responsive-fs(12);
      }
      .sorted_text {
        position: relative;
        top: 15px;
        color: #8a909a;
        height: 350px;
        @include responsive-fs(12);
      }
      .alert-message {
        position: relative;
        // 30pxはモーダルコンテンツのパディングです
        width: calc(100% + 30px);
        right: 15px;
        margin-top: 15px;
        .alert-dismissible {
          display: flex;
          align-items: center;
          .close {
            top: 3px !important;
            right: 0px !important;
            color: #ffffff;
            font-weight: 100;
          }
        }
        /deep/ .alert {
          border: none !important;
        }
        .alert-danger {
          width: 100%;
          height: fit-content;
          @include responsive-fs(15);
          display: flex;
          line-height: 120%;
          align-items: center;
          border: 1px solid#B41B3E;
          background-color: #b41b3e;
          color: #ffffff;
          margin: 0px;
        }
        .error-msg-container {
          width: 100%;
          height: fit-content;
          position: relative;
          margin: 0px 5px 5px 0px;
        }
        .animated-error-msg-container {
          height: 100%;
          position: relative;
          margin: 0px 5px 5px 0px;
          animation: hidden-message-animation 0.3s ease-in;
        }
        .error-msg-box {
          width: 100%;
          position: relative;
          top: 0;
          right: 30;
          animation: displayed-message-animation 0.3s ease-in;
        }

        .material-icons.report {
          @include responsive-fs(15);
          margin-right: 5px;
          margin-left: -10px;
        }

        .material-icons.check-circle {
          @include responsive-fs(15);
          margin-right: 5px;
          margin-left: -10px;
        }

        .material-icons.close-message {
          @include responsive-fs(15);
          margin-right: -10px;
        }

        .text-decoration-underline {
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .slide-enter-active {
        -moz-transition-duration: 0.3s;
        -webkit-transition-duration: 0.3s;
        -o-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -moz-transition-timing-function: ease-in;
        -webkit-transition-timing-function: ease-in;
        -o-transition-timing-function: ease-in;
        transition-timing-function: ease-in;
      }

      .slide-leave-active {
        -moz-transition-duration: 0.3s;
        -webkit-transition-duration: 0.3s;
        -o-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
      }

      .slide-enter-to,
      .slide-leave {
        max-height: 44px;
        overflow: hidden;
      }

      .slide-enter,
      .slide-leave-to {
        overflow: hidden;
        max-height: 0;
      }
      @keyframes displayed-message-animation {
        0% {
          height: 0px;
        }
        25% {
          height: 10px;
        }
        50% {
          height: 21px;
        }
        75% {
          height: 32px;
        }
        100% {
          height: 43px;
        }
      }
      @keyframes hidden-message-animation {
        0% {
          height: 25px;
        }
        25% {
          height: 20px;
        }
        50% {
          height: 17px;
        }
        75% {
          height: 10px;
        }
        100% {
          height: 0px;
        }
      }
    }
  }
  @media print {
    @page {
      size: portrait;
      page-break-inside: avoid;
      margin-left: 42px;
      margin-bottom: -0.01cm;
    }
    table {
      th, td {
        border: 2px solid #000000 !important;
        width: 25%;
      }
      th:first-child, td:first-child {
        border-right: none !important;
      }
      th:not(:first-child):not(:last-child), td:not(:first-child):not(:last-child) {
        border-left: none !important;
        border-right: none !important;
      }
      th:last-child, td:last-child {
        border-left: none !important;
      }
    }
    .item-tracking {
      @include responsive-fs(14);
      width: 99%;
      .search-group {
        margin-left: 18px;
      }
      .print-group {
        display: none;
      }
      .table-tracking-list {
        margin: 25px 30px 25px 30px;
        border-left: none !important;
        border-right: none !important;
        .lable-sort-chute {
          word-break: break-all;
          .icon-sort-chute-up {
            display: none;
          }
          .icon-sort-chute-down {
            display: none;
          }
          .non-icon-sort-chute-up {
            display: none;
          }
          .non-icon-sort-chute-down {
            display: none;
          }
        }

        .lable-sort-time {
          .icon-sort-time-up {
            display: none;
          }
          .non-icon-sort-time-up {
            display: none;
          }
          .icon-sort-time-down {
            display: none;
          }
          .non-icon-sort-time-down {
            display: none;
          }
        }
        .lable-box-number {
          word-break: break-all;
        }
        .lable-result-quantity {
          word-break: break-all;
        }
      }
       .empty_text{
        position: relative;
        top: 120px;
        left: 450px;
        color: #8a909a;
        @include responsive-fs(12);
      }
      .icon-sort {
        @include responsive-fs(14);
          padding: 0 2px;
          font-weight: 500;
      }
    }
    .no-item-tracking {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/ItemTrackingModal.vue